export default {
  sections: {
    alcohol_percentage: 'Alkoholipitoisuus: {{value}} %',
    price_per_unit: 'Hinta per {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ainesosat',
    allergens: 'Allergeenit',
    additives: 'Lisäaineet',
    nutrition_breakdown: {
      title: 'Ravintosisältö',
      description: '100 {{unit}} sisältää:',
      items: {
        energy: 'Energia',
        fat: 'Rasva',
        saturates: 'josta tyydyttynyttä rasvaa',
        carbohydrates: 'Hiilihydraatit',
        sugars: 'josta sokeria',
        protein: 'Proteiini',
        salt: 'Suola',
      },
    },
  },
  units: {
    l: 'litra',
    kg: 'kilo',
    default: 'yksikkö',
  },
};
